import { createAction } from '@reduxjs/toolkit'

import { TGroupApi } from 'types/GlobalGroup'
import { TAccount } from 'types/GlobalAccount'

// tryGetAllAccounts
export const getAll = createAction('get_all_accounts')
export const getAllSuccess = createAction<{ data: TAccount[] }>(
  'get_all_accounts_success'
)
export const getAllFailed = createAction('get_all_accounts_failed')

// tryUpdateUser
export const update = createAction('update_user')
export const updateSuccess = createAction<{
  account: TAccount
  groups: TGroupApi[]
}>('update_user_success')
export const updateFailed = createAction('update_user_failed')

// tryCreateUser
export const create = createAction('create_user')
export const createSuccess = createAction<{
  account: TAccount
  groups: TGroupApi[]
}>('create_user_success')
export const createFailed = createAction('create_user_failed')

// tryDeleteUsers
export const destroy = createAction('delete_users')
export const destroySuccess = createAction<{
  id: string
  groups: TGroupApi[]
}>('delete_users_success')
export const destroyFailed = createAction('delete_users_failed')
